<template>
  <div class="body">

    <v-snackbar
        class="text-center"
        v-model="snackbar"
        bottom
        color="success"
        style="direction: rtl; text-align: center"
        :timeout="1500"
    >
      {{ message }}
    </v-snackbar>


    <v-btn color="primary" @click.native.stop="dialog = true">New Level</v-btn>
    <v-dialog v-model="dialog" max-width="800">
      <v-container style="background-color: white">
        <v-form ref="form" v-model="valid" :lazy-validation="lazy">
          <p class="headline">Add Level:</p>
          <v-container>
            <v-text-field
                label="Name"
                :rules="requiredRules"
                v-model="model.name"
            ></v-text-field>
            <v-select
                label="Contract Template"
                v-model="selected_item"
                :items="items"
                item-text="name"
                return-object
            ></v-select>
            <div v-if="selected_item">
              <p class="grey--text">
                Percentage: {{ selected_item.percentage }}%,
                Per hour: {{ selected_item.per_hour }}%,
                Per KM: {{ selected_item.per_km }}%,
                Per booking: {{ selected_item.per_booking }}
              </p>
            </div>
            <v-select
                v-model="model.bonus_packages"
                label="Choose bonus packages"
                multiple
                :items="bonus_packages"
                item-value="id"
                item-text="name"
            ></v-select>
          </v-container>
          <!--                    <p>{{model.bonus_packages}}</p>-->

          <div class="text-center">

            <!--                        <v-menu-->
            <!--                                style="padding:10px; text-align: center"-->
            <!--                                :close-on-content-click="false"-->
            <!--                                :nudge-width="200"-->
            <!--                        >-->
            <!--                            <template  v-slot:activator="{ on, attrs }">-->
            <!--                                <v-btn-->
            <!--                                        color="grey"-->
            <!--                                        dark-->
            <!--                                        v-bind="attrs"-->
            <!--                                        v-on="on"-->
            <!--                                >-->
            <!--                                    Bonus Packages-->
            <!--                                </v-btn>-->
            <!--                            </template>-->

            <!--                            <v-list>-->
            <!--                                <v-list-item-->
            <!--                                        v-for="(item,index) in bonus_packages" :key="index"-->
            <!--                                >-->
            <!--                                    <v-checkbox-->
            <!--                                            v-model="model.bonus_packages"-->
            <!--                                            :label="item.name"-->
            <!--                                            :value="item.id"-->
            <!--                                    ></v-checkbox>-->
            <!--                                </v-list-item>-->
            <!--                            </v-list>-->
            <!--                        </v-menu>-->
          </div>

          <v-btn block color="primary" @click="submit">Submit</v-btn>
        </v-form>
      </v-container>
    </v-dialog>

    <data-table
        :url="url"
        title="Levels"
        :titles="titles"
        :fields-hidden-main="['updated_at','created_at','contract_template_id']"
        :formatter="formatter"
        :enable-edit="false"
        :enable-add="false"
        :disable-search="true"
    />

  </div>
</template>
<script>
import DataTable from "@/components/wasilni/DataTable";

export default {
  name: "Level",
  components: {DataTable},
  data() {
    return {
      dialog: false,
      loading: false,
      snackbar: false,
      message: "",
      valid: true,
      lazy: false,
      requiredRules: [(v) => !!v || "الحقل مطلوب"],
      items: null,
      bonus_packages: null,
      selected_item: null,
      model: {
        name: '',
        contract_template_id: null,
        bonus_packages: []
      },
      url: "contract_template/level"
    }
  },
  computed: {
    titles() {
      return {
        id: '#',
        name: 'Name',
        contract_template: 'Contract Template'
      }
    },
    formatter() {
      return {
        contract_template: (value) => {
          return value ? value.name : 'No contract Template'
        }
      }
    },
  },
  methods: {
    submit() {
      this.model.contract_template_id = this.selected_item.id;
      this.axios
          .post(
              "contract_template/level",
              this.model
          )
          .then((res) => {
            this.message = 'Saved';
            this.snackbar = true;
          })
          .catch((err) => {
            try {
              this.message = err.response.data.message;
            } catch (e) {
              this.message = "حدث خطأ";
            }
            this.snackbar = true;
          })
          .finally(() => (this.dialog = false));
    }
  },
  mounted() {
    this.axios
        .get("all_contract_template")
        .then((res) => this.items = res.data.data)
        .catch(err => console.log(err.message))
        .finally(() => this.loading = false);

    this.axios.get("bonus_package", {params: {all: true}})
        .then((res) => this.bonus_packages = res.data.data.data)
        .catch(err => console.log(err.message))
        .finally(() => this.loading = false);
  },

}
</script>

<style scoped>
.v-input {
  padding-left: 20px
}

.theme--dark .v-menu__content {
  background-color: #424242;
}

.theme--light .v-menu__content {
  background-color: #ffffff;
}

</style>
